import { API_ENDPOINTS } from "@api/ApiEndpoints";
import { useHttpClient } from "@hooks/utils/httpConfig";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { DropdownCategory } from "./types";

export interface DropdownValueDto {
  value: string;
  caption: string;
}

export function useDropdownOptionsQuery(
  category: DropdownCategory
): UseQueryResult<DropdownValueDto[]> {
  const client = useHttpClient();

  return useQuery({
    queryKey: ['dropdown-options', category],
    queryFn: async (): Promise<DropdownValueDto[]> => {
      const response = await client.get<DropdownValueDto[]>(
        API_ENDPOINTS.DROPDOWN_VALUES(category)
      );
      return response ?? [];
    },
    refetchOnWindowFocus: false,
    gcTime: 10 * 60 * 1000,
    staleTime: 5 * 60 * 1000,
  });
}
